import React from 'react';
import ReactDOM from 'react-dom';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { UxContext } from './UxContext';

const useStyles = makeStyles((theme: Theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

const Loading = () => {
    const uxCtx = React.useContext(UxContext);
    const isLoading = uxCtx?.isLoading;
    const classes = useStyles();

    if (isLoading) {
        return ReactDOM.createPortal(
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>,
            document.querySelector('#loading') as Element
        );
    }

    return null;
};

export default Loading;
